(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const stack = document.querySelector('.announcement-stack');

  if (stack) {
    const announcements = stack.querySelectorAll('.announcement');
    let current = 0;

    if (announcements.length > 0) {
      announcements[current].setAttribute('aria-hidden', 'false');

      requestAnimationFrame(() => {
        stack.classList.add('transitions');
      });

      if (announcements.length > 1) {
        setInterval(() => {
          announcements[current].setAttribute('aria-hidden', 'true');
          current = (current + 1) % announcements.length;
          announcements[current].setAttribute('aria-hidden', 'false');
        }, 7000);
      }
    }
  }

  const timerEl = document.querySelector('.countdown-timer');

  if (timerEl) {
    const raw = timerEl.dataset.end.trim();

    const m = raw.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/);

    if (!m) {
      timerEl.textContent = 'Invalid date';
    } else {
      const year = Number(m[1]);
      const month = Number(m[2]);
      const day = Number(m[3]);
      const hour = Number(m[4]);
      const minute = Number(m[5]);

      /* New York DST detection */
      function nyOffset(y, mo, d, h) {
        const march1 = new Date(Date.UTC(y, 2, 1));
        const secondSundayMarch = 14 - march1.getUTCDay();

        const nov1 = new Date(Date.UTC(y, 10, 1));
        const firstSundayNov = 7 - nov1.getUTCDay();

        const now = Date.UTC(y, mo - 1, d, h);

        const dstStart = Date.UTC(y, 2, secondSundayMarch, 7);
        const dstEnd = Date.UTC(y, 10, firstSundayNov, 6);

        return now >= dstStart && now < dstEnd ? 4 : 5;
      }

      const offset = nyOffset(year, month, day, hour);
      const TARGET = Date.UTC(year, month - 1, day, hour + offset, minute, 0);

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function render() {
        let diff = TARGET - Date.now();

        if (diff <= 0) {
          timerEl.textContent = '0s';
          return;
        }

        const days = Math.floor(diff / 86400000);
        diff %= 86400000;

        const hours = Math.floor(diff / 3600000);
        diff %= 3600000;

        const minutes = Math.floor(diff / 60000);
        diff %= 60000;

        const seconds = Math.floor(diff / 1000);

        const parts = [];

        if (days > 0) parts.push(days + 'd');
        if (hours > 0 || days > 0) parts.push(hours + 'h');
        if (minutes > 0 || hours > 0 || days > 0) parts.push(minutes + 'm');
        parts.push(seconds + 's');

        timerEl.textContent = parts.join(' ');
      }

      function tick() {
        render();
        const delay = 1000 - (Date.now() % 1000);
        setTimeout(tick, delay);
      }

      tick();

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) render();
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-all-articles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-filter]').forEach((root) => {
    const buttons = root.querySelectorAll('[data-filter-tag]');
    const cards = root.querySelectorAll('[data-article-card]');
    const empty = root.querySelector('[data-filter-empty]');
    const pagination = root.querySelector('[data-blog-pagination]');
    if (!buttons.length) return;

    const applyFilter = (tag) => {
      let shown = 0;
      cards.forEach((card) => {
        const tags = (card.getAttribute('data-article-tags') || '')
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);
        const match = !tag || tags.indexOf(tag) !== -1;
        card.hidden = !match;
        if (match) shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
      if (pagination) pagination.hidden = Boolean(tag);
      buttons.forEach((button) => {
        const active = (button.getAttribute('data-filter-tag') || '') === tag;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const filterFromLocation = () => {
      const handle = (window.location.hash || '').replace('#', '');
      let nextTag = '';
      buttons.forEach((button) => {
        if (handle && button.getAttribute('data-filter-handle') === handle) {
          nextTag = button.getAttribute('data-filter-tag') || '';
        }
      });
      applyFilter(nextTag);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const handle = button.getAttribute('data-filter-handle') || 'all';
        const url = new URL(window.location.href);
        if (handle === 'all') {
          history.replaceState(null, '', url.pathname + url.search);
        } else {
          url.hash = handle;
          history.replaceState(null, '', url);
        }
        applyFilter(button.getAttribute('data-filter-tag') || '');
      });
    });

    window.addEventListener('hashchange', filterFromLocation);
    filterFromLocation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-highlighted"]) return;
  try {
    
  (() => {
    const AUTOPLAY_DELAY = 3000;
    const SCROLL_DURATION = 300;
    const MOBILE_QUERY = '(width < 48rem)';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia(MOBILE_QUERY);

    const initHighlightedResources = (root) => {
      if (root.dataset.highlightedResourcesInitialized === 'true') return;
      root.dataset.highlightedResourcesInitialized = 'true';

      const track = root.querySelector('[data-highlighted-resources-track]');
      if (!track) return;

      const items = Array.from(track.children);
      const originalCount = Number(track.dataset.originalCount || items.length);
      const isInfiniteCarousel = originalCount > 3 && items.length > originalCount;
      const hasScrollButtons = Boolean(root.querySelector('[scroll-buttons]'));

      if (!isInfiniteCarousel && (originalCount <= 1 || !hasScrollButtons)) return;

      const originalStart = originalCount;
      const originalEnd = originalStart + originalCount - 1;

      let autoplayTimer;
      let animationFrame;
      let isPaused = false;
      let isFocused = false;
      let isDragging = false;
      let hasPointerMoved = false;
      let pointerStartX = 0;
      let pointerStartScrollLeft = 0;

      const getItemOffset = (index) => {
        const item = items[index];
        const leftAlignedOffset = item.offsetLeft - items[0].offsetLeft;

        if (!mobile.matches) return leftAlignedOffset;

        return item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
      };

      const normalizeIndex = (index) => {
        if (index < originalStart) return index + originalCount;
        if (index > originalEnd) return index - originalCount;
        return index;
      };

      const getNearestIndex = () => {
        return items.reduce((nearestIndex, item, index) => {
          const nearestDistance = Math.abs(track.scrollLeft - getItemOffset(nearestIndex));
          const distance = Math.abs(track.scrollLeft - getItemOffset(index));
          return distance < nearestDistance ? index : nearestIndex;
        }, 0);
      };

      const easeInOut = (progress) => {
        return progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
      };

      const jumpTo = (index) => {
        track.scrollLeft = getItemOffset(index);
      };

      const animateTo = (index) => {
        cancelAnimationFrame(animationFrame);

        const target = getItemOffset(index);
        const finish = () => {
          jumpTo(index);

          if (!isInfiniteCarousel) return;

          const normalizedIndex = normalizeIndex(index);
          if (normalizedIndex !== index) jumpTo(normalizedIndex);
        };

        if (reducedMotion.matches) {
          finish();
          return;
        }

        const start = track.scrollLeft;
        const distance = target - start;

        if (Math.abs(distance) < 1) {
          finish();
          return;
        }

        const startedAt = performance.now();

        const tick = (now) => {
          const progress = Math.min((now - startedAt) / SCROLL_DURATION, 1);
          track.scrollLeft = start + distance * easeInOut(progress);

          if (progress < 1) {
            animationFrame = requestAnimationFrame(tick);
            return;
          }

          finish();
        };

        animationFrame = requestAnimationFrame(tick);
      };

      const move = (direction) => {
        let currentIndex = getNearestIndex();

        if (!isInfiniteCarousel) {
          const nextIndex = Math.max(0, Math.min(items.length - 1, currentIndex + direction));
          if (nextIndex === currentIndex) return;
          animateTo(nextIndex);
          return;
        }

        if (currentIndex < originalStart || currentIndex > originalEnd) {
          currentIndex = normalizeIndex(currentIndex);
          jumpTo(currentIndex);
        }

        let nextIndex = currentIndex + direction;
        if (nextIndex >= items.length) nextIndex = originalStart;
        if (nextIndex < 0) nextIndex = originalEnd;

        animateTo(nextIndex);
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (isPaused || reducedMotion.matches) return;
        autoplayTimer = window.setInterval(() => move(1), AUTOPLAY_DELAY);
      };

      const resumeFromPointer = () => {
        isPaused = root.matches(':hover') || isFocused;
        startAutoplay();
      };

      const beginDrag = (clientX) => {
        cancelAnimationFrame(animationFrame);
        isDragging = true;
        hasPointerMoved = false;
        pointerStartX = clientX;
        pointerStartScrollLeft = track.scrollLeft;
        track.dataset.dragging = 'true';
        isPaused = true;
        stopAutoplay();
      };

      const updateDrag = (clientX) => {
        if (!isDragging) return false;

        const distance = clientX - pointerStartX;
        if (Math.abs(distance) > 4) hasPointerMoved = true;
        track.scrollLeft = pointerStartScrollLeft - distance;

        return hasPointerMoved;
      };

      const finishDrag = () => {
        if (!isDragging) return;

        isDragging = false;
        delete track.dataset.dragging;
        animateTo(getNearestIndex());
        resumeFromPointer();
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-highlighted-scroll]');
        if (!button) return;

        if (isInfiniteCarousel) stopAutoplay();
        move(button.dataset.highlightedScroll === 'right' ? 1 : -1);
        if (isInfiniteCarousel) startAutoplay();
      });

      if (isInfiniteCarousel) {
        root.addEventListener('mouseenter', () => {
          isPaused = true;
          stopAutoplay();
        });

        root.addEventListener('mouseleave', () => {
          isPaused = false;
          startAutoplay();
        });

        root.addEventListener('focusin', () => {
          isFocused = true;
          isPaused = true;
          stopAutoplay();
        });

        root.addEventListener('focusout', (event) => {
          if (root.contains(event.relatedTarget)) return;
          isFocused = false;
          isPaused = root.matches(':hover');
          startAutoplay();
        });

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch') return;

          beginDrag(event.clientX);
        });

        track.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch') return;
          if (updateDrag(event.clientX) && !track.hasPointerCapture?.(event.pointerId)) {
            track.setPointerCapture?.(event.pointerId);
          }
        });

        track.addEventListener('pointerup', finishDrag);
        track.addEventListener('pointercancel', finishDrag);
        track.addEventListener('lostpointercapture', finishDrag);

        track.addEventListener('dragstart', (event) => event.preventDefault());

        track.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          beginDrag(event.touches[0].clientX);
        }, { passive: true });

        track.addEventListener('touchmove', (event) => {
          if (event.touches.length !== 1) return;
          if (updateDrag(event.touches[0].clientX)) event.preventDefault();
        }, { passive: false });

        track.addEventListener('touchend', finishDrag);
        track.addEventListener('touchcancel', finishDrag);

        track.addEventListener('click', (event) => {
          if (!hasPointerMoved) return;
          event.preventDefault();
          hasPointerMoved = false;
        });

        window.addEventListener('resize', () => jumpTo(normalizeIndex(getNearestIndex())), { passive: true });
        reducedMotion.addEventListener?.('change', startAutoplay);

        jumpTo(originalStart);
        startAutoplay();
      }
    };

    const initAllHighlightedResources = () => {
      document.querySelectorAll('[data-highlighted-resources]').forEach(initHighlightedResources);
    };

    initAllHighlightedResources();
    document.addEventListener('shopify:section:load', initAllHighlightedResources);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  async function refreshCollectionGrid(url) {
    const grid = document.querySelector('.collection-grid');
    const sectionId = grid.dataset.sectionId;

    history.replaceState({}, '', url);

    const sectionUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;
    const res = await fetch(sectionUrl);
    const html = await res.text();

    const template = document.createElement('template');
    template.innerHTML = html;

    const newResults = template.content.querySelector('#results');
    const currentResults = document.querySelector('#results');
    currentResults.replaceWith(newResults);

    const newControls = template.content.querySelector('#controls');
    const currentControls = document.querySelector('#controls');
    currentControls.replaceWith(newControls);

    const newLabels = template.content.querySelectorAll('#filters label');
    const currentLabels = document.querySelectorAll('#filters label');

    newLabels.forEach((newLabel, index) => {
      if (currentLabels[index]) {
        currentLabels[index].innerHTML = newLabel.innerHTML;
      }
    });

    // Refresh pagination if it exists
    const newPagination = template.content.querySelector('#pagination');
    const currentPagination = document.querySelector('#pagination');

    if (newPagination && currentPagination) {
      currentPagination.replaceWith(newPagination);
    } else if (newPagination && !currentPagination) {
      const results = document.querySelector('#results');
      results.appendChild(newPagination);
    } else if (!newPagination && currentPagination) {
      currentPagination.remove();
    }

    const results = document.querySelector('#results');
    if (results) {
      const remInPixels = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const offset = results.getBoundingClientRect().top + window.scrollY - 8 * remInPixels;
      window.scrollTo({ top: offset, behavior: 'auto' });
    }

    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }

  const filters = document.querySelector('#filters');
  const backdrop = document.querySelector('.filters-backdrop');
  const close = document.querySelector('[aria-label="Close filters"]');

  function openFilters() {
    filters.setAttribute('open', '');
    backdrop.removeAttribute('hidden');
  }

  function closeFilters() {
    filters.removeAttribute('open');
    backdrop.setAttribute('hidden', '');
  }

  document.addEventListener('click', (e) => {
    if (e.target.matches('[aria-controls="filters"]')) {
      openFilters();
    }

    // Handle pagination clicks
    if (e.target.closest('#pagination a')) {
      e.preventDefault();
      const url = e.target.closest('a').href;
      refreshCollectionGrid(url);
    }
  });

  close?.addEventListener('click', closeFilters);
  backdrop?.addEventListener('click', closeFilters);

  const priceRangeMin = document.querySelector('[name="filter.v.price.gte"]');
  const priceRangeMax = document.querySelector('[name="filter.v.price.lte"]');
  const minPriceDisplay = document.querySelector('#min-price');
  const maxPriceDisplay = document.querySelector('#max-price');

  function updateRangeHighlight() {
    const min = parseInt(priceRangeMin.value);
    const max = parseInt(priceRangeMax.value);
    const rangeMin = parseInt(priceRangeMin.min);
    const rangeMax = parseInt(priceRangeMin.max);

    const leftPercent = ((min - rangeMin) / (rangeMax - rangeMin)) * 100 + 1;
    const rightPercent = ((rangeMax - max) / (rangeMax - rangeMin)) * 100 + 1;

    const slider = document.querySelector('.price-range-slider');
    slider.style.setProperty('--range-left', leftPercent + '%');
    slider.style.setProperty('--range-right', rightPercent + '%');
  }

  if (priceRangeMin && priceRangeMax) {
    updateRangeHighlight();

    priceRangeMin.addEventListener('input', (e) => {
      const minVal = parseInt(e.target.value);
      const maxVal = parseInt(priceRangeMax.value);

      if (minVal >= maxVal) {
        e.target.value = maxVal - 1000;
      }

      if (minPriceDisplay) {
        const minDollars = (e.target.value / 100).toFixed(2);
        minPriceDisplay.textContent = '$' + minDollars;
      }

      updateRangeHighlight();
    });

    priceRangeMax.addEventListener('input', (e) => {
      const minVal = parseInt(priceRangeMin.value);
      const maxVal = parseInt(e.target.value);

      if (maxVal <= minVal) {
        e.target.value = minVal + 1000;
      }

      if (maxPriceDisplay) {
        const maxDollars = (e.target.value / 100).toFixed(2);
        maxPriceDisplay.textContent = '$' + maxDollars;
      }

      updateRangeHighlight();
    });

    priceRangeMin.addEventListener('change', applyPriceRangeFilter);
    priceRangeMax.addEventListener('change', applyPriceRangeFilter);
  }

  function applyPriceRangeFilter() {
    const currentUrl = new URL(window.location.href);
    const minVal = parseInt(priceRangeMin.value);
    const maxVal = parseInt(priceRangeMax.value);
    const maxPossible = parseInt(priceRangeMax.max);

    const minDollars = (minVal / 100).toFixed(2);
    const maxDollars = (maxVal / 100).toFixed(2);

    if (minVal > 0) {
      currentUrl.searchParams.set('filter.v.price.gte', minDollars);
    } else {
      currentUrl.searchParams.delete('filter.v.price.gte');
    }

    if (maxVal < maxPossible) {
      currentUrl.searchParams.set('filter.v.price.lte', maxDollars);
    } else {
      currentUrl.searchParams.delete('filter.v.price.lte');
    }

    refreshCollectionGrid(currentUrl.pathname + currentUrl.search);
  }

  document.addEventListener('change', (e) => {
    if (e.target.matches('input[type="checkbox"]')) {
      const url = e.target.checked ? e.target.dataset.urlAdd : e.target.dataset.urlRemove;
      if (!url) return;
      refreshCollectionGrid(url);
    }

    if (e.target.matches('[name="collection-sort-select"]')) {
      const sortValue = e.target.value;
      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.set('sort_by', sortValue);
      refreshCollectionGrid(currentUrl.pathname + currentUrl.search);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-events"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-community-events]').forEach((root) => {
      const track = root.querySelector('[data-events-track]');
      const slides = [...root.querySelectorAll('[data-events-slide]')];
      const prev = root.querySelector('[data-scroll="left"]');
      const next = root.querySelector('[data-scroll="right"]');
      if (!track || !slides.length) return;

      let index = 0;
      const update = () => {
        track.style.transform = `translateX(-${index * 100}%)`;
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= slides.length - 1;
      };

      prev?.addEventListener('click', () => {
        if (index <= 0) return;
        index -= 1;
        update();
      });
      next?.addEventListener('click', () => {
        if (index >= slides.length - 1) return;
        index += 1;
        update();
      });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-giving"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCommunityGiving = (root) => {
      if (!root || root.dataset.givingReady === 'true') return;
      root.dataset.givingReady = 'true';

      const track = root.querySelector('[data-giving-track]');
      const prevButtons = [...root.querySelectorAll('[data-scroll="left"]')];
      const nextButtons = [...root.querySelectorAll('[data-scroll="right"]')];
      if (!track || !prevButtons.length) return;

      let isDragging = false;
      let pointerStartX = 0;
      let pointerStartScrollLeft = 0;

      const step = () => {
        const card = track.firstElementChild;
        if (!card) return 0;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        if (!root.isConnected) {
          window.removeEventListener('resize', update);
          return;
        }
        const max = track.scrollWidth - track.clientWidth;
        const atStart = track.scrollLeft <= 1;
        const atEnd = track.scrollLeft >= max - 1;
        prevButtons.forEach((button) => {
          button.disabled = atStart;
        });
        nextButtons.forEach((button) => {
          button.disabled = atEnd;
        });
      };

      const scrollByCard = (direction) => {
        const distance = step();
        if (!distance) return;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };

      const beginDrag = (clientX) => {
        isDragging = true;
        pointerStartX = clientX;
        pointerStartScrollLeft = track.scrollLeft;
        track.dataset.dragging = 'true';
      };

      const updateDrag = (clientX) => {
        if (!isDragging) return false;
        const distance = clientX - pointerStartX;
        track.scrollLeft = pointerStartScrollLeft - distance;
        return Math.abs(distance) > 4;
      };

      const finishDrag = () => {
        if (!isDragging) return;
        isDragging = false;
        delete track.dataset.dragging;
        update();
      };

      prevButtons.forEach((button) => {
        button.addEventListener('click', () => scrollByCard(-1));
      });
      nextButtons.forEach((button) => {
        button.addEventListener('click', () => scrollByCard(1));
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;
        if (event.target.closest('a.community-giving-link')) return;
        beginDrag(event.clientX);
      });

      track.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;
        if (updateDrag(event.clientX) && !track.hasPointerCapture?.(event.pointerId)) {
          track.setPointerCapture?.(event.pointerId);
        }
      });

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', finishDrag);
      track.addEventListener('dragstart', (event) => event.preventDefault());

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollByCard(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollByCard(-1);
        }
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-community-giving]').forEach(initCommunityGiving);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-podcasts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCommunityPodcasts = (root) => {
      if (!root || root.dataset.podcastsReady === 'true') return;
      root.dataset.podcastsReady = 'true';

      const track = root.querySelector('[data-podcast-track]');
      const prevButtons = [...root.querySelectorAll('[data-scroll="left"]')];
      const nextButtons = [...root.querySelectorAll('[data-scroll="right"]')];
      if (!track) return;

      let isDragging = false;
      let pointerStartX = 0;
      let pointerStartScrollLeft = 0;

      const step = () => {
        const card = track.firstElementChild;
        if (!card) return 0;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        if (!root.isConnected) {
          window.removeEventListener('resize', update);
          return;
        }
        const max = track.scrollWidth - track.clientWidth;
        const atStart = track.scrollLeft <= 1;
        const atEnd = track.scrollLeft >= max - 1;
        prevButtons.forEach((button) => {
          button.disabled = atStart;
        });
        nextButtons.forEach((button) => {
          button.disabled = atEnd;
        });
      };

      const scrollByCard = (direction) => {
        const distance = step();
        if (!distance) return;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };

      const beginDrag = (clientX) => {
        isDragging = true;
        pointerStartX = clientX;
        pointerStartScrollLeft = track.scrollLeft;
        track.dataset.dragging = 'true';
      };

      const updateDrag = (clientX) => {
        if (!isDragging) return false;

        const distance = clientX - pointerStartX;
        track.scrollLeft = pointerStartScrollLeft - distance;

        return Math.abs(distance) > 4;
      };

      const finishDrag = () => {
        if (!isDragging) return;

        isDragging = false;
        delete track.dataset.dragging;
        update();
      };

      prevButtons.forEach((button) => {
        button.addEventListener('click', () => scrollByCard(-1));
      });
      nextButtons.forEach((button) => {
        button.addEventListener('click', () => scrollByCard(1));
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;
        if (event.target.closest('a.community-podcast-listen')) return;
        beginDrag(event.clientX);
      });

      track.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;
        if (updateDrag(event.clientX) && !track.hasPointerCapture?.(event.pointerId)) {
          track.setPointerCapture?.(event.pointerId);
        }
      });

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', finishDrag);
      track.addEventListener('dragstart', (event) => event.preventDefault());

      track.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            scrollByCard(1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            scrollByCard(-1);
          }
        }
      );
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-community-podcasts]').forEach(initCommunityPodcasts);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AUTO_MS = 4000;

    const initCarousel = (root) => {
      const track = root.querySelector('.community-spotlight-carousel-track');
      if (!track) return;

      const slides = Array.from(track.children);
      if (slides.length < 2) return;

      const dots = Array.from(root.querySelectorAll('.community-spotlight-carousel-dot'));
      const prevBtn = root.querySelector('.community-spotlight-carousel-nav.prev');
      const nextBtn = root.querySelector('.community-spotlight-carousel-nav.next');
      const captionEl = root.querySelector('[data-carousel-caption]');

      let slideWidth = track.clientWidth;
      let ticking = false;
      let timer = null;

      const getIndex = () => Math.round(track.scrollLeft / Math.max(slideWidth, 1));

      const updateCaption = (index) => {
        if (!captionEl) return;
        const slide = slides[index];
        const nextCaption = slide?.dataset?.caption || '';
        captionEl.textContent = nextCaption;
        captionEl.hidden = !nextCaption;
      };

      const updateActiveDot = () => {
        const index = getIndex();
        dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('active', '');
          else dot.removeAttribute('active');
        });
        updateCaption(index);
      };

      const scrollToSlide = (index) => {
        const nextIndex = ((index % slides.length) + slides.length) % slides.length;
        track.scrollTo({
          left: slideWidth * nextIndex,
          behavior: 'smooth',
        });
      };

      const stopAuto = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      const startAuto = () => {
        stopAuto();
        timer = setInterval(() => {
          scrollToSlide(getIndex() + 1);
        }, AUTO_MS);
      };

      track.addEventListener('scroll', () => {
        if (ticking) return;
        requestAnimationFrame(() => {
          updateActiveDot();
          ticking = false;
        });
        ticking = true;
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.index, 10);
          if (!Number.isNaN(idx)) {
            scrollToSlide(idx);
            startAuto();
          }
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          scrollToSlide(getIndex() - 1);
          startAuto();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          scrollToSlide(getIndex() + 1);
          startAuto();
        });
      }

      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('mouseleave', startAuto);
      root.addEventListener('focusin', stopAuto);
      root.addEventListener('focusout', (e) => {
        if (!root.contains(e.relatedTarget)) startAuto();
      });

      const resizeObserver = new ResizeObserver(() => {
        slideWidth = track.clientWidth;
      });
      resizeObserver.observe(track);

      updateActiveDot();
      startAuto();
    };

    document
      .querySelectorAll('[data-community-spotlight-carousel]')
      .forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-parent"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq-parent]').forEach((explorer) => {
    const searchInput = explorer.querySelector('[data-faq-search]');
    const empty = explorer.querySelector('[data-faq-empty]');

    const setExpanded = (item, expanded) => {
      const button = item.querySelector(':scope > .accordion-row > .accordion-button');
      const panel = button && document.getElementById(button.getAttribute('aria-controls'));
      if (!button || !panel) return;
      button.setAttribute('aria-expanded', String(expanded));
      panel.inert = !expanded;
    };

    const applySearch = () => {
      const query = (searchInput && searchInput.value ? searchInput.value : '').trim().toLowerCase();
      const items = explorer.querySelectorAll('[data-faq-item]');
      const groupToggles = explorer.querySelectorAll('.faq-group-toggle');

      if (!query) {
        explorer.classList.remove('is-searching');
        items.forEach((item) => item.classList.remove('is-match'));
        explorer.querySelectorAll('.has-match').forEach((el) => el.classList.remove('has-match'));
        groupToggles.forEach((groupItem) => setExpanded(groupItem, false));
        if (empty) empty.hidden = true;
        return;
      }

      explorer.classList.add('is-searching');
      let matchCount = 0;

      items.forEach((item) => {
        if (item.classList.contains('faq-group-toggle')) {
          item.classList.remove('is-match');
          return;
        }
        const haystack = (item.getAttribute('data-search') || '').toLowerCase();
        const match = haystack.includes(query);
        item.classList.toggle('is-match', match);
        if (match) matchCount += 1;
      });

      groupToggles.forEach((groupItem) => {
        const hasChildMatch = groupItem.querySelector('[data-faq-item].is-match') != null;
        groupItem.classList.toggle('is-match', hasChildMatch);
        setExpanded(groupItem, hasChildMatch);
      });

      explorer.querySelectorAll('[data-faq-group]').forEach((group) => {
        group.classList.toggle('has-match', group.querySelector('.faq-item.is-match') != null);
      });

      if (empty) empty.hidden = matchCount > 0;
    };

    if (searchInput) searchInput.addEventListener('input', applySearch);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glossary"]) return;
  try {
    
  document.addEventListener('change', function (e) {
    if (e.target.id !== 'mobile-az') return;

    const value = e.target.value;
    if (!value) return;

    window.location = value;
    e.target.value = '';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menu = document.querySelector('#menu');
  const mobileNav = document.querySelector('.mobile-nav');
  const header = document.getElementById('shopify-section-header');
  const announcement = document.getElementById('shopify-section-announcement-bar');

  function updateCartCount(count) {
    const link = document.querySelector('a[aria-label="Cart"]');
    if (!link) return;
    const n = Number(count) || 0;

    if (n <= 0) {
      const wrap = link.querySelector('.relative');
      if (!wrap) return;
      while (wrap.firstChild) {
        if (wrap.firstChild.tagName === 'SPAN') wrap.firstChild.remove();
        else link.insertBefore(wrap.firstChild, wrap);
      }
      wrap.remove();
      return;
    }

    let wrap = link.querySelector('.relative');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'relative';
      while (link.firstChild) wrap.appendChild(link.firstChild);
      link.appendChild(wrap);
    }

    let badge = wrap.querySelector('span');
    if (!badge) {
      badge = document.createElement('span');
      wrap.appendChild(badge);
    }
    const label = String(n);
    if (badge.textContent !== label) badge.textContent = label;
  }

  function cartDrawerSectionHtml(data) {
    const sections = data && data.sections;
    if (!sections) return null;
    if (typeof sections['cart-drawer'] === 'string') return sections['cart-drawer'];
    const key = Object.keys(sections).find((name) => name === 'cart-drawer' || name.endsWith('-cart-drawer'));
    return key ? sections[key] : null;
  }

  window.replaceCartDrawer = function (sectionHtml) {
    if (!sectionHtml) return false;
    const template = document.createElement('template');
    template.innerHTML = sectionHtml;

    const newDrawer = template.content.querySelector('#cart-drawer');
    const currentDrawer = document.querySelector('#cart-drawer');
    if (!newDrawer || !currentDrawer) return false;

    const scroller = currentDrawer.querySelector(':has(> .line-item)');
    const scrollTop = scroller ? scroller.scrollTop : 0;

    currentDrawer.innerHTML = newDrawer.innerHTML;

    const nextScroller = currentDrawer.querySelector(':has(> .line-item)');
    if (nextScroller) nextScroller.scrollTop = scrollTop;
    const count = newDrawer.getAttribute('data-cart-count');
    if (count != null) updateCartCount(count);
    currentDrawer.removeAttribute('aria-busy');
    return true;
  };

  window.refreshCartDrawer = async function () {
    const root = window.Shopify?.routes?.root || '/';
    const res = await fetch(`${root}?section_id=cart-drawer`);
    if (!res.ok) throw new Error('Failed to refresh cart drawer');
    const html = await res.text();
    if (!window.replaceCartDrawer(html)) throw new Error('Failed to refresh cart drawer');
  };

  async function submitCartChange(endpoint, body) {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error('Failed to update cart');
    const data = await response.json();

    if (!window.replaceCartDrawer(cartDrawerSectionHtml(data))) {
      throw new Error('Failed to update cart');
    }

    if (typeof window.__runBundlerCartSync === 'function') {
      window.__runBundlerCartSync(data);
    } else if (window.bndlr && typeof window.bndlr.updateCartDiscounts === 'function') {
      window.bndlr.updateCartDiscounts();
    }

    if (window.location.pathname.startsWith('/cart')) {
      await window.refreshCartPage();
    }

    return data;
  }

  function lineItemForIndex(lineIndex) {
    return document.querySelectorAll('#cart-drawer .line-item')[lineIndex - 1]
      || document.querySelectorAll('.cart-page .line-item')[lineIndex - 1]
      || null;
  }

  window.changeCartLine = async function (lineIndex, quantity) {
    const lineItem = lineItemForIndex(lineIndex);
    const isGusLine = lineItem
      ? (lineItem.textContent || '').toLowerCase().includes('gus')
      : true;

    if (!isGusLine) {
      return submitCartChange('/cart/change.js', {
        line: lineIndex,
        quantity,
        sections: ['cart-drawer'],
      });
    }

    const cartRes = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    if (!cartRes.ok) throw new Error('Failed to fetch cart');
    const cart = await cartRes.json();
    const items = cart.items || [];

    const isGus = (item) => typeof item.title === 'string' && item.title.toLowerCase().includes('gus');
    const isArcAudio = (item) => typeof item.title === 'string' && item.title.toLowerCase().includes('arc audio');

    const targetLine = items[lineIndex - 1];

    const gusItems = items.filter(isGus);
    const totalGusBefore = gusItems.reduce((sum, item) => sum + item.quantity, 0);

    let totalGusAfter = totalGusBefore;
    if (targetLine && isGus(targetLine)) {
      totalGusAfter = totalGusBefore - targetLine.quantity + Math.max(0, quantity);
    }

    const willHaveNoGus = targetLine && isGus(targetLine) && totalGusAfter === 0;

    if (willHaveNoGus) {
      const updates = {};
      updates[targetLine.key] = quantity;

      items.filter(isArcAudio).forEach((item) => {
        updates[item.key] = 0;
      });

      return submitCartChange('/cart/update.js', {
        updates,
        sections: ['cart-drawer'],
      });
    }

    return submitCartChange('/cart/change.js', {
      line: lineIndex,
      quantity,
      sections: ['cart-drawer'],
    });
  };

  window.refreshProductSection = async function () {
    const section = document.querySelector('.product-main')?.closest('[id^="shopify-section-"]');

    if (!section) return;

    const sectionId = section.id.replace('shopify-section-', '');
    const res = await fetch(`${window.location.pathname}?section_id=${sectionId}`);

    const html = await res.text();
    const template = document.createElement('template');
    template.innerHTML = html;

    const newSection = template.content.querySelector(`#${CSS.escape(section.id)}`);
    if (!newSection) return;

    const currentButton = section.querySelector("button[type='submit']");
    const newButton = newSection.querySelector("button[type='submit']");

    if (!currentButton || !newButton) return;
    currentButton.replaceWith(newButton);
  };

  window.refreshCartPage = async function () {
    const section = document.querySelector('.cart-page');
    if (!section) return;

    const sectionId = section.id.replace('shopify-section-', '');
    const res = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
    if (!res.ok) throw new Error('Failed to refresh cart page');

    const html = await res.text();
    const template = document.createElement('template');
    template.innerHTML = html;

    const newSection = template.content.querySelector(`#${CSS.escape(section.id)}`);
    if (!newSection) return;

    section.replaceWith(newSection);

    if (typeof window.syncCartPageRewardsFromDrawer === 'function') {
      window.syncCartPageRewardsFromDrawer();
    }
  };

  function getVisibleHeight(el) {
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, viewportHeight);

    return Math.max(0, visibleBottom - visibleTop);
  }

  function updateMobileNavOffset() {
    const headerHeight = header?.offsetHeight || 0;
    const announcementVisibleHeight = announcement
      ? getVisibleHeight(announcement)
      : 0;

    const offset = headerHeight + announcementVisibleHeight;

    mobileNav.style.setProperty('--offset', `${offset}px`);
  }

  menu.addEventListener('click', () => {
    updateMobileNavOffset();

    const isOpen = menu.classList.contains('open');

    if (isOpen) {
      menu.classList.remove('open');
      menu.classList.add('closed');
    } else {
      menu.classList.add('open');
      menu.classList.remove('closed');
    }

    mobileNav.toggleAttribute('open');
    mobileNav.toggleAttribute('inert');
  });

  mobileNav.addEventListener('click', (e) => {
    const panelOpener = e.target.closest('[data-target]');
    if (panelOpener) {
      const target = panelOpener.dataset.target;
      const panel = mobileNav.querySelector(`[data-panel="${CSS.escape(target)}"]`);
      panel?.toggleAttribute('data-active');
      return;
    }

    const backButton = e.target.closest('.mobile-nav-back');
    if (backButton) {
      const activePanel = mobileNav.querySelector('[data-active]');
      activePanel?.toggleAttribute('data-active', false);
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[aria-label="Account"]');
    const popover = document.getElementById('account-popover');

    if (btn) {
      popover?.toggleAttribute('open');
      return;
    }

    if (!popover?.contains(e.target)) {
      popover?.removeAttribute('open');
    }
  });

  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[aria-label="Close"]');
    if (!closeBtn) return;
    if (closeBtn.closest('#bundle-protected-dialog')) return;

    const drawer = closeBtn.closest('#cart-drawer');
    if (!drawer) return;

    e.preventDefault();

    drawer.toggleAttribute('closing', true);

    drawer.addEventListener(
      'transitionend',
      (evt) => {
        if (evt.propertyName !== 'transform') return;
        drawer.toggleAttribute('closing', false);
        drawer.close();
      },
      { once: true }
    );
  });

  document.addEventListener('click', (e) => {
    const cartLink = e.target.closest('a[aria-label="Cart"]');
    if (!cartLink) return;

    if (window.location.pathname.startsWith('/cart')) return;

    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    e.preventDefault();

    if (!drawer.open) {
      drawer.showModal();
    }
  });

  document.addEventListener('click', (event) => {
    const deleteButton = event.target.closest('.delete-button');
    if (!deleteButton) return;

    const lineIndex = Number(deleteButton.dataset.line);
    if (!lineIndex) return;

    const lineItem = deleteButton.closest('.line-item');

    if (lineItem?.hasAttribute('data-bundle-protected')) {
      window.showBundleProtectedDialog?.();
      return;
    }

    if (lineItem) lineItem.inert = true;

    const startHeight = lineItem.offsetHeight;
    lineItem.style.height = `${startHeight}px`;

    lineItem.getBoundingClientRect();

    lineItem.toggleAttribute('deleting');
    lineItem.style.height = '0px';

    lineItem.addEventListener(
      'transitionend',
      (e) => {
        if (e.target !== lineItem || e.propertyName !== 'height') return;
        lineItem.remove();
      },
      { once: true }
    );

    window.changeCartLine(lineIndex, 0).catch(() => {
      if (lineItem) lineItem.inert = false;
    });
  });

  const desktopNavQuery = window.matchMedia('(min-width: 61rem)');

  function throttle(fn, wait) {
    let lastCall = 0;
    let timeout = null;

    return function (...args) {
      const now = Date.now();
      const remaining = wait - (now - lastCall);

      if (remaining <= 0) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        lastCall = now;
        fn.apply(this, args);
      } else if (!timeout) {
        timeout = setTimeout(() => {
          lastCall = Date.now();
          timeout = null;
          fn.apply(this, args);
        }, remaining);
      }
    };
  }

  function initHeaderScrollHide() {
    let lastScrollTop = window.scrollY;
    let hasRun = window.scrollY > (announcement?.offsetHeight || 0) + header.offsetHeight;
    let pinned = false;
    let unpinTimer = null;

    function pin() {
      clearTimeout(unpinTimer);
      if (pinned) {
        header.classList.add('scroll-up-visible');
        return;
      }
      header.classList.add('no-transition', 'scroll-up');
      header.offsetHeight;
      header.classList.remove('no-transition');
      pinned = true;
      requestAnimationFrame(() => header.classList.add('scroll-up-visible'));
    }

    function unpin() {
      clearTimeout(unpinTimer);
      header.classList.remove('scroll-up-visible');
      unpinTimer = setTimeout(() => {
        if (!header.classList.contains('scroll-up-visible')) {
          header.classList.remove('scroll-up');
          pinned = false;
        }
      }, 400);
    }

    function reset() {
      clearTimeout(unpinTimer);
      header.classList.remove('no-transition', 'scroll-up', 'scroll-up-visible');
      pinned = false;
      hasRun = false;
    }

    window.addEventListener(
      'scroll',
      throttle(function () {
        if (desktopNavQuery.matches) return;
        if (mobileNav.hasAttribute('open')) return;

        const st = Math.max(0, window.scrollY);
        const announcementHeight = announcement?.offsetHeight || 0;

        if (st <= announcementHeight) {
          reset();
          lastScrollTop = st;
          return;
        }

        if (st > lastScrollTop) {
          if (!hasRun) {
            if (pinned) unpin();
            hasRun = true;
          }
        } else {
          if (hasRun) {
            pin();
            hasRun = false;
          }
        }

        lastScrollTop = st;
      }, 16),
      { passive: true }
    );

    window.addEventListener(
      'resize',
      throttle(function () {
        if (desktopNavQuery.matches) reset();
      }, 100),
      { passive: true }
    );
  }

  initHeaderScrollHide();

  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) return;

  new MutationObserver(() => {
    cartDrawer.inert = !cartDrawer.open;
  }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-who-we-are"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const wrapper = event.target.closest('.video-wrapper');
    if (!wrapper) return;

    const embedUrl = wrapper.dataset.embedUrl + '?autoplay=1&rel=0';

    const iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.title = 'YouTube video player';
    iframe.frameBorder = '0';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';

    wrapper.replaceChildren(iframe);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["information-guide-deep-dive"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.vertical-tablist button');
    if (!btn) return;

    const id = btn.getAttribute('aria-controls');
    if (!id) return;

    const panel = document.getElementById(id);
    if (!panel) return;

    let anchor = panel;
    while (anchor && getComputedStyle(anchor).position === 'absolute') {
      anchor = anchor.parentElement;
    }
    if (!anchor) return;

    requestAnimationFrame(() => {
      const wrapper = anchor.closest('[tabpanels]');

      const doScroll = () => {
        if (!needsScroll(anchor)) return;

        const prev = document.documentElement.style.overflowAnchor;
        document.documentElement.style.overflowAnchor = 'none';

        const scroller = document.scrollingElement || document.documentElement;

        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const offset = 4 * rem;

        const y = anchor.getBoundingClientRect().top + scroller.scrollTop - offset;
        scroller.scrollTop = y;

        requestAnimationFrame(() => {
          document.documentElement.style.overflowAnchor = prev;
        });
      };

      if (!wrapper) {
        doScroll();
        return;
      }

      let done = false;
      const onEnd = (e) => {
        if (e.target !== wrapper || e.propertyName !== 'height') return;
        if (done) return;
        done = true;
        wrapper.removeEventListener('transitionend', onEnd);
        doScroll();
      };

      wrapper.addEventListener('transitionend', onEnd);

      requestAnimationFrame(() => {
        if (done) return;
        done = true;
        wrapper.removeEventListener('transitionend', onEnd);
        doScroll();
      });
    });
  });

  function needsScroll(anchor) {
    const rect = anchor.getBoundingClientRect();

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const offset = 4 * rem;

    return rect.top < offset || rect.top > window.innerHeight;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-performance-scores"]) return;
  try {
    
  const select = document.querySelector('select[name="score-sort"]');
  const rows = [...document.querySelectorAll('.score-grid')];

  function parseFirstNumber(value) {
    const raw = String(value).trim();
    if (/^n\/a/i.test(raw)) return 0;
    const match = raw.match(/-?\d+(\.\d+)?/);
    return match ? Number(match[0]) : 0;
  }

  function applySort() {
    const option = select.selectedOptions[0];
    const key = select.value;
    let max = Number(option.dataset.max);
    const claimedLegend = document.querySelector('.claimed-legend');
    const showClaimedLegend = key === 'xmaxBl' || key === 'xmaxCms' || key === 'xmaxLe' || key === 'xmaxFirst';

    if (claimedLegend) {
      claimedLegend.style.display = showClaimedLegend ? 'flex' : '';
    }

    if (!max) {
      for (const row of rows) {
        const n = parseFirstNumber(row.dataset[key]);
        if (n > max) max = n;
      }
    }

    for (const row of rows) {
      const rawValue = row.dataset[key];
      const value = parseFirstNumber(rawValue);
      const progress = row.querySelector('progress');
      const progressBars = row.querySelector('.progress-bars');
      const valueText = progressBars.nextElementSibling;
      const trimmed = String(rawValue).trim();

      progress.max = max;
      progress.value = value;

      if (key === 'xmaxBl' || key === 'xmaxCms' || key === 'xmaxLe' || key === 'xmaxFirst') {
        const claimed = String(row.dataset.xmaxClaimed || '').trim();
        const displayValue = trimmed || value;
        valueText.textContent = displayValue;
        if (claimed) {
          const claimedSpan = document.createElement('span');
          claimedSpan.textContent = ` (${claimed})`;
          claimedSpan.className = 'claimed';
          valueText.appendChild(claimedSpan);
        }
        const claimedValue = parseFirstNumber(claimed);
        const claimPct = max ? (claimedValue / max) * 100 : 0;
        progressBars.style.setProperty('--claim-pct', `${Math.min(Math.max(claimPct, 0), 100)}%`);
        progressBars.style.setProperty('--claim-visible', claimedValue ? '1' : '0');
      } else {
        valueText.textContent = trimmed.startsWith('>') ? `>${value}` : value;
      }
      if (key !== 'xmaxBl' && key !== 'xmaxCms' && key !== 'xmaxLe' && key !== 'xmaxFirst') {
        progressBars.style.setProperty('--claim-visible', '0');
      }
    }

    rows
      .sort((a, b) => {
        return parseFirstNumber(b.dataset[key]) - parseFirstNumber(a.dataset[key]);
      })
      .forEach((row) => row.parentNode.appendChild(row));
  }

  select.addEventListener('change', applySort);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  document.querySelectorAll('.shopify-section').forEach((section) => {
    if (section.children.length === 0) {
      section.remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ours-vs-others"]) return;
  try {
    
  function initCompare(component) {
    const viewport = component.querySelector('[compare-viewport]');
    const table = component.querySelector('[compare-table]');
    const button = component.querySelector('[compare-toggle]');

    if (!viewport || !table || !button) return;

    const threshold = Number(viewport.dataset.threshold);
    const rows = table.querySelectorAll('tbody tr');

    if (rows.length <= threshold) {
      viewport.removeAttribute('precollapsed');
      button.remove();
      return;
    }

    let expanded = false;
    let collapsedHeight = 0;
    let fullHeight = 0;

    function measure() {
      fullHeight = table.offsetHeight;

      const cutoffRow = rows[threshold - 1];
      if (!cutoffRow) {
        viewport.removeAttribute('precollapsed');
        return;
      }

      collapsedHeight = cutoffRow.offsetTop + cutoffRow.offsetHeight + 1;

      if (!expanded) {
        viewport.style.height = `${collapsedHeight}px`;
        viewport.removeAttribute('precollapsed');
      }
    }

    function expand() {
      expanded = true;
      viewport.classList.add('animating');
      viewport.style.height = `${fullHeight}px`;
      button.setAttribute('aria-expanded', 'true');
      button.firstElementChild.textContent = 'Show less';
    }

    function collapse() {
      expanded = false;
      viewport.classList.add('animating');
      viewport.style.height = `${collapsedHeight}px`;
      button.setAttribute('aria-expanded', 'false');
      button.firstElementChild.textContent = 'Show more';
    }

    button.hidden = false;

    button.addEventListener('click', () => {
      expanded ? collapse() : expand();
    });

    window.addEventListener('resize', measure);

    document.fonts?.ready.then(measure);
    window.addEventListener('load', measure, { once: true });
    requestAnimationFrame(measure);
  }

  document.querySelectorAll('.compare-component').forEach(initCompare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-carousel"] && !Shopify.designMode) return;
  try {
    
  const getRecommendedCarousel = (target) => {
    const btn = target.closest('.recommended-products [data-scroll]');
    if (!btn) return {};

    const section = btn.closest('.recommended-products');
    const container = section?.querySelector('[data-recommendations-track]');
    return { btn, section, container };
  };

  const recommendedMobileQuery = window.matchMedia('(max-width: 767px)');

  const getRecommendedRealItems = (container) =>
    Array.from(container.children).filter((item) => !item.hasAttribute('data-recommendation-clone'));

  const getRecommendedCenteredScrollLeft = (container, item) => {
    const itemWidth = item.getBoundingClientRect().width;
    const target = item.offsetLeft - (container.clientWidth - itemWidth) / 2;
    const max = container.scrollWidth - container.clientWidth;

    return Math.round(Math.min(max, Math.max(0, target)));
  };

  const getRecommendedClone = (item, position) => {
    const clone = item.cloneNode(true);
    clone.setAttribute('data-recommendation-clone', position);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((focusable) => {
      focusable.setAttribute('tabindex', '-1');
    });

    return clone;
  };

  const removeRecommendedEdgeClones = (container) => {
    container.querySelectorAll('[data-recommendation-clone]').forEach((clone) => clone.remove());
    delete container.dataset.mobileStartApplied;
  };

  const syncRecommendedEdgeClones = (container) => {
    if (!recommendedMobileQuery.matches) {
      removeRecommendedEdgeClones(container);
      return;
    }

    if (container.querySelector('[data-recommendation-clone]')) return;

    const items = getRecommendedRealItems(container);
    if (items.length < 2) return;

    container.prepend(getRecommendedClone(items[items.length - 1], 'before-first'));
    container.append(getRecommendedClone(items[0], 'after-last'));
    delete container.dataset.mobileStartApplied;
  };

  const getRecommendedScrollStep = (container) => {
    const item = container.children[0];
    if (!item) return 0;

    const styles = getComputedStyle(container);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);
    return item.getBoundingClientRect().width + gap;
  };

  const getRecommendedActiveIndex = (container) => {
    const items = getRecommendedRealItems(container);
    const containerCenter = container.scrollLeft + container.clientWidth / 2;
    let activeIndex = 0;
    let activeDistance = Infinity;

    items.forEach((item, index) => {
      const itemCenter = item.offsetLeft + item.getBoundingClientRect().width / 2;
      const distance = Math.abs(containerCenter - itemCenter);

      if (distance < activeDistance) {
        activeDistance = distance;
        activeIndex = index;
      }
    });

    return activeIndex;
  };

  const applyRecommendedMobileStartPosition = (section) => {
    const container = section.querySelector('[data-recommendations-track]');
    if (!container) return;

    const items = getRecommendedRealItems(container);
    const startIndex = Number(container.dataset.mobileStartIndex || 0);
    if (container.dataset.mobileStartApplied === 'true') return;
    if (!recommendedMobileQuery.matches) return;
    if (items.length <= startIndex) return;

    const max = container.scrollWidth - container.clientWidth;
    if (max <= 1) return;

    container.scrollTo({
      left: getRecommendedCenteredScrollLeft(container, items[startIndex]),
      behavior: 'auto',
    });
    container.dataset.mobileStartApplied = 'true';
  };

  const updateRecommendedScrollButtons = (section) => {
    const container = section.querySelector('[data-recommendations-track]');
    const canScroll = container && container.scrollWidth - container.clientWidth > 1;

    section.querySelectorAll('[data-scroll]').forEach((btn) => {
      btn.disabled = !canScroll;
    });
  };

  document.addEventListener(
    'click',
    (e) => {
      const { btn, section, container } = getRecommendedCarousel(e.target);
      if (!btn || !section || !container) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const direction = btn.dataset.scroll === 'right' ? 1 : -1;
      const max = container.scrollWidth - container.clientWidth;
      if (max <= 1 || !container.children.length) return;

      if (!recommendedMobileQuery.matches) {
        const step = getRecommendedScrollStep(container);
        if (!step) return;

        let target = container.scrollLeft + direction * step;
        if (direction > 0 && container.scrollLeft >= max - 1) {
          target = 0;
        } else if (direction < 0 && container.scrollLeft <= 1) {
          target = max;
        } else {
          target = Math.min(max, Math.max(0, target));
        }

        container.scrollTo({ left: Math.round(target), behavior: 'smooth' });
        updateRecommendedScrollButtons(section);
        return;
      }

      const items = getRecommendedRealItems(container);
      if (!items.length) return;

      const activeIndex = getRecommendedActiveIndex(container);
      let targetIndex = activeIndex + direction;
      if (targetIndex >= items.length) {
        targetIndex = 0;
      } else if (targetIndex < 0) {
        targetIndex = items.length - 1;
      }

      const targetItem = items[targetIndex];
      const target = getRecommendedCenteredScrollLeft(container, targetItem);

      container.scrollTo({ left: Math.round(target), behavior: 'smooth' });
      updateRecommendedScrollButtons(section);
    },
    true
  );

  document.querySelectorAll('.recommended-products').forEach((section) => {
    const container = section.querySelector('[data-recommendations-track]');
    if (!container) return;

    const update = () => {
      syncRecommendedEdgeClones(container);
      updateRecommendedScrollButtons(section);
      applyRecommendedMobileStartPosition(section);
    };

    container.addEventListener('scroll', () => updateRecommendedScrollButtons(section), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
  });

  } catch(e) { console.error(e); }
})();
})();
